export const searchAutocompleteQuery = `
  query SearchAutocomplete($search: String!) {
    AutoComplete(search: $search) {
      success
      correction
      categories {
        id
        name
        direct
        link_url
        image_url
      }
      sts {
        st
        amount
        redirectUrl
      }
    }
  }
`;

export const initialBelarusSearchQuery = `
  query InitialBelarusSearch($search: String!) {
    SearchProducts(search: $search) {
      success
      categories { id name link_url }
      sts { st }
    }
  }
`;

export const initialSearchAutocompleteQuery = `
  query InitialSearchAutocomplete($search: String!) {
    AutoComplete(search: $search) {
      success
      categories {
        id
        name
        direct
        link_url
        image_url
      }
      sts {
        st
        amount
        redirectUrl
      }
    }
  }
`;

export const searchCategoriesQuery = `
  query SearchCategories($search: String!) {
    AutoComplete(search: $search) {
      success
      categories {
        id
        name
        direct
        link_url
        image_url
      }
    }
  }
`;

export const searchCustomProductsQuery = `
  query SearchCustomProducts($pageSize: Int = 4, $currentPage: Int = 1) {
    getSearchProducts(pageSize: $pageSize, currentPage: $currentPage) {
      custom_title
      custom_products {
        sku
        name
        url
        price
        old_price
        price_range {
          minimum_price {
            final_price {
              value
            }
          }
          maximum_price {
            final_price {
              value
            }
          }
        }
        image
      }
    }
  }
`;
